import { generateTranslations } from '../i18n/translation';

const namespace = 'practiceactivity/oppsummering';

const translations = generateTranslations(namespace, {
  oversikt: {
    nb: 'Oversikt',
    en: 'Overview',
  },
  praksissted: {
    nb: 'Praksissted',
    en: 'Place',
  },
  status: {
    nb: 'Status',
    en: 'Status',
  },
  studenter: {
    nb: 'Studenter',
    en: 'Students',
  },
  kapasitet: {
    nb: 'Kapasitet',
    en: 'Capacity',
  },
  ledig: {
    nb: 'Ledige plasser',
    en: 'Available places',
  },
  fylt: {
    nb: 'Fylt',
    en: 'Full',
  },
});

export default translations;
